import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const PeripheralPulses = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
      <Autocomplete
        value={moduleValues?.['Peripheral Pulses'] ?? []}
        options={[
            "Radial Pulse Present",
  "Radial Pulse Absent",
  "Radial Pulse Normal",
  "Radial Pulse Weak",
  "Brachial Pulse Present",
  "Brachial Pulse Absent",
  "Brachial Pulse Normal",
  "Brachial Pulse Weak",
  "Femoral Pulse Present",
  "Femoral Pulse Absent",
  "Femoral Pulse Normal",
  "Femoral Pulse Weak",
  "Popliteal Pulse Present",
  "Popliteal Pulse Absent",
  "Popliteal Pulse Normal",
  "Popliteal Pulse Weak",
  "Dorsalis Pedis Pulse Present",
  "Dorsalis Pedis Pulse Absent",
  "Dorsalis Pedis Pulse Normal",
  "Dorsalis Pedis Pulse Weak",
  "Posterior Tibial Pulse Present",
  "Posterior Tibial Pulse Absent",
  "Posterior Tibial Pulse Normal",
  "Posterior Tibial Pulse Weak",
        ]}
        multiple
        
        onChange={(e, value) => setModuleValues(prev => ({...prev, ['Peripheral Pulses']: value}))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Peripheral Pulses"
          />
        )}
      />
    </Grid>

)

export default PeripheralPulses
